import { useState } from 'react'
import useEdgeDataFetcher from './useEdgeDataFetcher'

export default () => {
  const [appointmentData, sendRequestAppointment] = useState(false)
  const [response] = useEdgeDataFetcher(appointmentData && `/appointment?a=b`, JSON.stringify(appointmentData), 'PUT')
  let sending = appointmentData && !response ? true : false
  let isSent = appointmentData && response ? true : false
  return [sending, isSent, sendRequestAppointment]
}
